var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSmartphone = function SvgSmartphone(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Smartphone",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-Icons-\\u2705",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "AZ_DLS_Icons",
    transform: "translate(-321.000000, -230.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Library_Items-/-Title-/-Descriptions-Copy-7",
    transform: "translate(33.000000, 165.000000)",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 16,
    letterSpacing: -0.0266666671
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 1.086957)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "App",
    transform: "translate(321.000000, 230.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,1.01053323 C11.8284271,1.01053323 12.5,1.6821061 12.5,2.51053323 L12.5,2.51053323 L12.5,13.5017 C12.5,14.3301271 11.8284271,15.0017 11,15.0017 L11,15.0017 L5,15.0017 C4.17157288,15.0017 3.5,14.3301271 3.5,13.5017 L3.5,13.5017 L3.5,2.51053323 C3.5,1.6821061 4.17157288,1.01053323 5,1.01053323 L5,1.01053323 Z M11,2.01053323 L5,2.01053323 C4.72385763,2.01053323 4.5,2.23439085 4.5,2.51053323 L4.5,2.51053323 L4.5,13.5017 C4.5,13.7778423 4.72385763,14.0017 5,14.0017 L5,14.0017 L11,14.0017 C11.2761424,14.0017 11.5,13.7778423 11.5,13.5017 L11.5,13.5017 L11.5,2.51053323 C11.5,2.23439085 11.2761424,2.01053323 11,2.01053323 L11,2.01053323 Z M9.0064747,12.0076341 L9.0064747,13.0076341 L7.00757347,13.0076341 L7.00757347,12.0076341 L9.0064747,12.0076341 Z M9.99328309,2.99766702 L9.99328309,3.99766702 L6.00560251,3.99766702 L6.00560251,2.99766702 L9.99328309,2.99766702 Z",
    id: "Combined-Shape"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSmartphone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "smartphone.9176fa60a2ab342e25071b8d281ff970.svg";